<template>
    <div class="menu-wrap">
        <el-menu :defaultActive="navIndex" class="el-menu-vertical-demo" active-text-color="#cd7dfe" :router="true">
            <el-menu-item class="pc-btn" index="-1" :route="{path:'/add'}">
                <el-button slot="title" type="primary" style="width:100%">发布</el-button>
            </el-menu-item>
            <el-menu-item :key="m.id" v-for="m in navList" :index="m.id" :route="{path:m.path}">
                <i :class="m.icon"></i>
                <span slot="title">{{m.name}}</span>
            </el-menu-item>
            <el-menu-item class="phone-btn" index="-1" :route="{path:'/add'}">
                <el-button slot="title" type="primary" style="width:100%">发布</el-button>
            </el-menu-item>
        </el-menu>
        <div class="content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapMutations
    } from "vuex";
    export default {
        data() {
            return {
                navIndex: "1",
                navList: [{
                    id: "1",
                    name: "首页",
                    path: "/my",
                    icon: "el-icon-house"
                }, {
                    id: "2",
                    name: "作品管理",
                    path: "/admin",
                    icon: "el-icon-folder-opened",
                }, {
                    id: "3",
                    name: "创作百科",
                    path: "/ques",
                    icon: "el-icon-magic-stick",
                }],
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
            this.checkPath(this.$route);
            if (!this.s_getUser) {
                this._home();
            }
            this.setMeta("我的", 1);
        },
        mounted() {
            // 在组件被挂载之后调用。
        },
        methods: {
            // ...mapMutations([])
            checkPath(t) {
                let p = t.path;
                let arr = this.navList;
                for (let i = 0, len = arr.length; i < len; i++) {
                    if (p == arr[i].path) {
                        this.navIndex = arr[i].id;
                        break;
                    }
                }
            },
        },
        computed: {
            // 计算属性
            ...mapGetters(["s_getUser"]),
        },
        watch: {
            // 监听
            $route(to, from) {
                // 路径判断
                this.checkPath(to);
            },
            s_getUser(n) {
                if (!n) {
                    this._home();
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    .menu-wrap {
        display: flex;

        .iconfont {
            font-size: 20px;
            margin-right: 10px;
        }

        .content {
            flex: 1;
            width: 0;
            min-height: 100vh;
            background: #ffff;
            padding: 10px;
        }
    }

    .el-menu-vertical-demo {
        width: 200px;
    }

    /deep/.el-menu-item:focus,
    /deep/.el-menu-item:hover {
        // background-color: #ebf7ff;
        background-color: transparent;
    }

    .pc-btn {
        display: block;
    }

    .phone-btn {
        display: none;
    }

    /* 移动端 */
    @media (max-width: 600px) {
        .pc-btn {
            display: none;
        }

        .phone-btn {
            display: inline-block;
        }

        .menu-wrap {
            display: block;

            .content {
                width: 100%;
                box-sizing: border-box;
            }

            .iconfont {
                margin-right: 0;
            }
        }

        .el-menu-vertical-demo {
            display: flex;
            width: 100%;
            overflow-x: auto;
            box-sizing: border-box;

            span {
                display: none;
            }
        }
    }
</style>